import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { splitterIcon } from '../AppIcons';
import jQuery from "jquery";
import $ from "jquery";
import APIUrls from "../services/APIUrls";
import axiosInstance from "../services/axiosInstance";
import InContextUtil from "../services/InContextUtil";
import Constants from "../Constants";
import { useNavigate } from 'react-router-dom';
import SuccessNotification from './SuccessNotification';
import FeedbackForm from './FeedbackForm';



export default function LineByLine({isLineByLineActive, projectId, editedTusCount,activeFilter,onFilterChange, isFinalPreviewChecked, feedbackCount,leveragedTuCount,lockedTuCount,aipeTuCount ,onFeedbackCountUpdate,currentUserEmail,feedbackCategories,feedbackSeverities}) {   

    const navigate = useNavigate();
    const parentHttpDomain = process.env.REACT_APP_PUBLIC_URL;
    const [translationUnits, setTranslationUnits] = useState([])
    const currentSelectedTUHtml = useRef();
    const currentTranslationUnitId = useRef();
    const currentDocSegPos = useRef();
    const currentProjectTranslationAssetId = useRef();
    const feedbackCategoryList = useRef([]);
    const feedbackSeverityList = useRef([]);
    const [showSuccessNotification, setShowSuccessNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [showFeedbackForm, setShowFeedbackForm] = useState(false);
    const [feedbackFormPosition, setFeedbackFormPosition] = useState({});
    const [isLoadingFilter, setIsLoadingFilter] = useState(false);
    const validateAccess = async () => {
        try {
            const { data } = await axiosInstance.get(APIUrls.ASSET_ACCESS_CHECK(projectId));
            if (!data) {
                navigate('/access/denied');
                return false;
            }
            return true;
        } catch (error) {
            navigate('/access/denied');
            return false;
        }
    };

    
    let menuHtml = `<div id='contextMenu' class='icr-options'>
                                    <ul class='icr-options-list'>
                                        <li class="hide feedback-option">
                                            <button aria-label='provide feedback' id='provide-feedback' aria-expanded='false'>Provide Feedback</button>
                                        </li>
                                        <li class="hide edit-option">
                                            <button aria-label='Edit Translation' id='edit-tu' aria-expanded='false'>Edit Translation</button>
                                            <div class='provide-feedback-form save-edit hide' id='edit-tu-container'>
                                                <div class='icr-compact-modal'>
                                                    <div class='icr-compact-body'>
                                                    <h4 class='icr-compact-title'>Save Edits</h4>
                                                    <div class='icr-compact-row'>
                                                        <select id='feedbackCategoryOptions' class='icr-compact-select'>
                                                        <option value=''>Select Category (Optional)</option>
                                                        </select>
                                                    </div>
                                                    <div class='icr-compact-row'>
                                                        <select id='feedbackSeverityOptions' class='icr-compact-select'>
                                                        <option value=''>Select Severity (Optional)</option>
                                                        </select>
                                                    </div>
                                                    <div class='icr-compact-actions'>
<button aria-label='cancel' class='icr-compact-btn icr-compact-ghost' id='edit-tu-cancel'>Cancel</button>
<button aria-label='submit' class='icr-compact-btn icr-compact-primary' id='edit-tu-submit'>Save</button>
</div>
                                                    </div>
                                                </div>
                                                </div>
                                        </li>
                                        <li class="hide bookmark-option">
                                            <button aria-label='bookmark' id='bookmark'>Bookmark</button>
                                        </li>
                                        <li>
                                            <button aria-label='show history' id='show-history'>Show History</button>                                                                                        
                                        </li>
                                        <li class="hide remove-bookmark-option">
                                            <button aria-label='Remove Bookmark' id='remove-bookmark'>Remove Bookmark</button>                                                                                        
                                        </li>
                                        <li>
                                            <button aria-label='close menu' id='close-tu-menu'>Close Menu</button>                                                                                        
                                        </li>
                                    </ul>
                                </div>`;


    $(function ($) {
        $("#line-by-line-view-content .relative").on("scroll", function () {
            $("#line-by-line-view-content .relative").scrollTop($(this).scrollTop());
        });
    });

    // --- helper functions copied from IcrPreview for consistent display formatting ---
    function formatCategoryType(type) {
        if (!type) return '';
        return type
            .toLowerCase()
            .replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase())
            .trim();
    }

    function formatCategoryName(name) {
        if (!name) return '';
        return name.toLowerCase().replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase())
            .replace(/3rd Party/g, '3rd Party');
    }


    
    useEffect(() => {
        feedbackCategoryList.current = feedbackCategories || [];
        feedbackSeverityList.current = feedbackSeverities || [];
    }, [feedbackCategories, feedbackSeverities]);


    useEffect(() => {
        // remove and re-insert authoritative styles
        jQuery('#icr-compact-modal-styles').remove();
        jQuery('<style id="icr-compact-modal-styles">').text(`
        /* ---------- Modal container: slightly less horizontal ---------- */
        .icr-compact-modal {
        box-sizing: border-box !important;
        transform: scale(0.9);
        transform-origin: top left; 
        width: 320px !important;       
        max-width: 320px !important;
        min-width: 320px !important;
        margin-right: -48px !important;
        margin-left: -5px !important; 
        margin-bottom: -38px !important;
        display: block !important;
        }

        /* ---------- Body: reduce left padding so content shifts left ---------- */
        .icr-compact-body {
        padding: 18px 18px 18px 12px !important;  /* left padding decreased to 12px */
        font-family: "Helvetica Neue", Arial, sans-serif !important;
        color: rgb(42,66,116) !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        line-height: 20px !important;
        text-align: left !important;
        }

        /* ---------- Title: flush left, slightly up ---------- */
        .icr-compact-title {
        margin: -15px 0px 15px -11px !important;  /* moved up slightly and flush left */
        font-size: 15px !important;
        font-weight: 600px !important;
        color: rgb(42,66,116) !important;
        text-align: left !important;
        }

        /* ---------- Vertical spacing ---------- */
        .icr-compact-row {
        margin: 8px 0 16px 0 !important;
        }

        /* ---------- Selects: full width, aligned left inside smaller modal ---------- */
        .icr-compact-select {
        display: block !important;
        margin-left: -12px !important;
        width: calc(100% + 0px) !important;
        min-height: 44px !important;
        padding: 10px 48px 10px 12px !important;      /* right padding for caret; left padding comfortable */
        font-family: "Helvetica Neue", Arial, sans-serif !important;
        font-size: 14px !important;
        font-weight: 450 !important;
        line-height: 20px !important;
        color: #000000 !important;
        border-radius: 8px !important;
        border: 1px solid #d7ddec !important;
        box-sizing: border-box !important;
        background-color: #fff !important;
        -webkit-appearance: none !important;
        -moz-appearance: none !important;
        appearance: none !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;

        
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14'%3E%3Cpath d='M3 5l4 4 4-4' stroke='%234b5563' stroke-width='2' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E") !important;
        background-repeat: no-repeat !important;
        background-position: calc(100% - 8px) center !important;
        background-size: 14px 14px !important;
        }

        /* placeholder styling */
        .icr-compact-select.icr-placeholder { color: #6b7280 !important; font-weight: 400 !important; }

        .icr-compact-select option { font-size: 14px !important; font-weight: 400 !important; padding: 6px 6px !important; }

        /* ---------- Actions: spacing and equal button sizes ---------- */
        .icr-compact-actions {
        display: flex !important;
        justify-content: flex-end !important;
        gap: 14px !important;
        margin-top: 27px !important;
        margin-right: 11px !important;
        }

        .icr-compact-btn {
        min-width: 100px !important;
        height: 35.16px !important;
        padding: 0 8px !important;
        font-size: 14px !important;
        font-weight: 400 !important;  /* less bold font */
        border-radius: 4px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        cursor: pointer !important;
        }

        .icr-compact-ghost { background: #fff !important; border: 1px solid #1D4ED8 !important; color: #1D4ED8 !important; }
        .icr-compact-primary { background: #1D4ED8 !important; border: none !important; color: #fff !important; }

        /* focus */
        .icr-compact-select:focus { outline: none !important; box-shadow: 0 0 0 4px rgba(51,102,204,0.06) !important; }

        /* avoid parent flex interference */
        #contextMenu .icr-compact-body,
        #contextMenu .icr-compact-modal,
        .icr-compact-body,
        .icr-compact-modal { align-items: initial !important; justify-content: initial !important; }

        /* mobile */
        @media (max-width:620px) {
        .icr-compact-modal { width: 92vw !important; min-width: unset !important; }
        .icr-compact-select { min-height:44px !important; padding:10px 40px 10px 10px !important; }
        .icr-compact-btn { min-width:96px !important; height:40px !important; font-size:14px !important; }
        }
        `).appendTo('head');

        // placeholder helper (mark selects with empty value)
        const $selects = jQuery('.icr-compact-select');
        $selects.each(function () {
            const $s = jQuery(this);
            if ($s.val() === '' || $s.val() == null) $s.addClass('icr-placeholder'); else $s.removeClass('icr-placeholder');
        });
        $selects.off('change.icrPlaceholder').on('change.icrPlaceholder', function () {
            const $s = jQuery(this);
            if ($s.val() === '' || $s.val() == null) $s.addClass('icr-placeholder'); else $s.removeClass('icr-placeholder');
        });
    }, []);
    
    
    useEffect(() => {
    // Handle feedback button click
    jQuery(document).off("click", "#provide-feedback").on("click", "#provide-feedback", function (e) {
        const button = e.target;
        const buttonRect = button.getBoundingClientRect();
        
        
        const desiredTop = buttonRect.bottom + window.scrollY - 5; 
        const desiredRight = window.innerWidth - buttonRect.right;
        
        
        const formHeight = 409; 
        const spaceBelow = window.innerHeight - buttonRect.bottom;
        
        let finalTop;
        let finalRight = desiredRight;
        
        if (spaceBelow < formHeight) {
            
            finalTop = buttonRect.top + window.scrollY - formHeight + 5; 
        } else {
            
            finalTop = desiredTop;
        }
        
        const formWidth = 320; 
        const spaceRight = buttonRect.right;
        
        if (spaceRight < formWidth) {
            finalRight = window.innerWidth - buttonRect.left;
        }
        
        setFeedbackFormPosition({
            top: finalTop,
            right: finalRight
        });
        
        jQuery("#contextMenu").remove();
        setShowFeedbackForm(true);
    });

    return () => {
        jQuery(document).off("click", "#provide-feedback");
    };
}, []);

    
    const handleFeedbackSubmit = async (feedbackData) => {
        if (!(await validateAccess())) return;

        if (!currentDocSegPos.current || !currentProjectTranslationAssetId.current) {
            setNotificationMessage("Error: Please select a translation unit before submitting feedback");
            setShowSuccessNotification(true);
            return;
        }

        const payload = {
            comment: feedbackData.comment,
            startPosition: null,
            stopPosition: null,
            feedback: {
                category: feedbackData.category || null,
                severity: feedbackData.severity || null
            }
        };

        try {
            const response = await axiosInstance.post(
                APIUrls.SUBMIT_FEEDBACK(currentProjectTranslationAssetId.current, currentDocSegPos.current),
                payload
            );
            onFeedbackCountUpdate(response.data.feedbackCount || feedbackCount + 1);
            setNotificationMessage('Feedback submitted successfully');
            setShowSuccessNotification(true);
            setShowFeedbackForm(false);
            
            if (activeFilter === "COMMENTED") { 
                getTus("COMMENTED");
            }
        } catch (err) {
            console.error('Error submitting feedback:', err);
            const errorMessage = err.response?.data?.message || err.message;
            setNotificationMessage(`Failed to submit feedback: ${errorMessage}`);
            setShowSuccessNotification(true);
        }
    };

    
    const handleFeedbackCancel = () => {
        setShowFeedbackForm(false);
    };




    useEffect(() => {
        if (isLineByLineActive && activeFilter === null) {
            getTranslationUnits(projectId);
        }
    }, [isLineByLineActive, projectId, activeFilter])

    useEffect(() => {
        if (isLineByLineActive) {
            sameHeight();
            undoMarkEditableContent();
        }
    }, [isLineByLineActive])

    useEffect(() => {
        // When activeFilter changes, update the display accordingly
        const fetchData = async () => {
            if (!isLineByLineActive) return;
            if (activeFilter === "EDITED") {
                await getEditedTus("EDITED");
            } else if (activeFilter === "COMMENTED") {
                await getTus("COMMENTED");
            }else if (activeFilter === "TM") {
                await getTus("TM");
            }else if (activeFilter === "LOCKED") {
                await getTus("LOCKED");
            }else if (activeFilter === "AIPE") {
                await getTus("AIPE");
            }else {
                await getTranslationUnits(projectId);
            }
        };

        if (isLineByLineActive) {
            fetchData();
        }
    }, [activeFilter, isLineByLineActive, projectId]);

    


    useLayoutEffect(() => {
        sameHeight();
    }, [translationUnits]);


    useEffect(() => {
        const fetchData = async () => {
            if (activeFilter === "EDITED") {
                await getEditedTus("EDITED");
            } else if (activeFilter === "COMMENTED") {
                await getTus("COMMENTED");
            } else if (activeFilter === "TM") {
                await getTus("TM");
            }else if (activeFilter === "LOCKED") {
                await getTus("LOCKED");
            }else if (activeFilter === "AIPE") {
                await getTus("AIPE");
            } else {
                await getTranslationUnits(projectId);
            }
        };
        fetchData();
    }, [activeFilter, projectId]);

    function toggleEditFilter() {
        if (isLoadingFilter) return;

        if (activeFilter === "EDITED") {
            onFilterChange(null);
            window.parent.postMessage(JSON.stringify({
                action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
                selectedFilter: "EDITED"
            }), '*');
        } else {
            setIsLoadingFilter(true);
            onFilterChange("EDITED");
            getEditedTus("EDITED").finally(() => {
                setIsLoadingFilter(false);
            });
        }
    }

    function toggleFeedbackFilter() {
        if (isLoadingFilter) return;

        if (activeFilter === "COMMENTED") {
            onFilterChange(null);
            window.parent.postMessage(JSON.stringify({
                action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
                selectedFilter: "COMMENTED"
            }), '*');
        } else {
            setIsLoadingFilter(true);
            onFilterChange("COMMENTED");
            getTus("COMMENTED").finally(() => {
                setIsLoadingFilter(false);
            });
        }
    }

    function toggleLeveragedTuFilter() {        
        if (isLoadingFilter) return;

        if (activeFilter === "TM") {
            onFilterChange(null);
            window.parent.postMessage(JSON.stringify({
                action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
                selectedFilter: "TM"
            }), '*');
        } else {
            setIsLoadingFilter(true);
            onFilterChange("TM");
            getTus("TM").finally(() => {
                setIsLoadingFilter(false);
            });
        }
    }

    function toggleAIPETuFilter() {        
        if (isLoadingFilter) return;

        if (activeFilter === "AIPE") {            
            onFilterChange(null);
            window.parent.postMessage(JSON.stringify({
                action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
                selectedFilter: "AIPE"
            }), '*');
        } else {            
            setIsLoadingFilter(true);
            onFilterChange("AIPE");
            getTus("AIPE").finally(() => {
                setIsLoadingFilter(false);
            });
        }
    }

    function toggleLockedTuFilter() {        
        if (isLoadingFilter) return;

        if (activeFilter === "LOCKED") {
            onFilterChange(null);
            window.parent.postMessage(JSON.stringify({
                action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
                selectedFilter: "LOCKED"
            }), '*');
        } else {
            setIsLoadingFilter(true);
            onFilterChange("LOCKED");
            getTus("LOCKED").finally(() => {
                setIsLoadingFilter(false);
            });
        }
    }

    const refreshFeedbackList = () => {
        getTus(activeFilter);
        
    };

    async function getEditedTus(selectedFilter) {
        try {
            
            const response = await axiosInstance.get(APIUrls.PROJECT_TRANSLATED_FILE_TRANSLATION_UNITS(projectId, 1, selectedFilter));
            prepSegmentDataAndSetTranslationUnits(response?.data);
        } catch (error) {
            console.error(error);
        } 
    }

    async function getTus(selectedFilter) {
        try {
            let response ;
            switch (selectedFilter) {
                    case "COMMENTED":
                        response = await axiosInstance.get(APIUrls.FEEDBACK_TRANSLATION_UNITS(projectId, 1));
                        break;
                    case "TM":
                        response = await axiosInstance.get(APIUrls.LEVERAGED_TRANSLATION_UNITS(projectId, 1));
                        break;
                    case "LOCKED":
                        response = await axiosInstance.get(APIUrls.LOCKED_TRANSLATION_UNITS(projectId, 1));
                        break;
                    case "AIPE":
                        response = await axiosInstance.get(APIUrls.AIQE_TRANSLATION_UNITS(projectId, 1));
                        break;    
                    default:
                        response = await axiosInstance.get(APIUrls.PROJECT_TRANSLATED_FILE_TRANSLATION_UNITS(projectId, 1));
                        break;
                    }                            
            prepSegmentDataAndSetTranslationUnits(response?.data);
        } catch (error) {
            console.error(error);
        } 
    }


    async function getTranslationUnits(translationId) {
        try {
            const response = await axiosInstance.get(APIUrls.RECENT_TRANSLATION_UNITS(translationId));
            const updatedTranslationUnit = transformBlankToNull(response?.data);
            prepSegmentDataAndSetTranslationUnits(updatedTranslationUnit);
        } catch (error) {
            console.error("Error fetching translation units:", error);
        }
    }

    function prepSegmentDataAndSetTranslationUnits(translationUnits) {
        translationUnits?.forEach(function (segment) {
            segment.translations[segment.translations.length - 1].tokenizedText = InContextUtil.tokenizeSegmentContent(segment.translations[segment.translations.length - 1].rawText,  Constants.STANDARD);
        });
        setTranslationUnits(translationUnits);        
    }

    const transformBlankToNull = (obj) => {
        return JSON.parse(JSON.stringify(obj, (key, value) => {
            return (value === "" ? null : value);
        }));
    };


    function sameHeight() {
        $("#line-by-line-view-content .video-translated-content li").height("");
        var lineHeight = 0;
        $("#line-by-line-view-content .video-translated-content li").each(function () {
            if ($(this).height() > lineHeight) {
                lineHeight = $(this).height();
            }
        });
        $("#line-by-line-view-content .video-translated-content li").height(lineHeight);
    }



    const handleClickKeydown =  (event, docSegPos, projectTranslationAssetId) => {
        if (event.key === Constants.ENTER) {
            handleClick(event, docSegPos, projectTranslationAssetId);
        }
    }

    //--------------------------------------HANDKLE CLICK STARTS-----------------------------------------------------

    const handleClick =  (event, docSegPos, projectTranslationAssetId) => {

        setShowFeedbackForm(false);        

        if (currentTranslationUnitId.current !== event?.currentTarget?.id) {
            jQuery("#contextMenu").remove();
            if (jQuery("span#" + currentTranslationUnitId.current).attr("edit-mode")) {
                jQuery("span#" + currentTranslationUnitId.current).removeAttr("edit-mode");
            }
            jQuery("#" + currentTranslationUnitId.current + " > .tu-html").html(currentSelectedTUHtml.current);
        }

        $('.linebykeydown').attr('aria-expanded', 'true');
        currentTranslationUnitId.current = event?.currentTarget?.id;

        let selector = jQuery("#" + event?.currentTarget?.id);
        if (jQuery("#" + event?.currentTarget?.id + " > .tu-html").has("span[contenteditable=true]").length === 0) {
            currentSelectedTUHtml.current = jQuery("#" + event?.currentTarget?.id + " > .tu-html").html();
            currentDocSegPos.current = docSegPos;
            currentProjectTranslationAssetId.current = projectTranslationAssetId;
        }
        if (!jQuery("span#" + event?.currentTarget?.id).attr("edit-mode")) {
            jQuery("#contextMenu").remove();
            selector.after(menuHtml);
        }
        else {
            if (selector.has("span[contenteditable=true]")) {
                jQuery("#edit-tu").trigger("click");
            }
        }

        jQuery(".edit-option").removeClass("hide");
        jQuery(".bookmark-option").removeClass("hide");
        jQuery(".feedback-option").removeClass("hide");


        if (selector.hasClass("bookmark")) {
            jQuery(".bookmark-option").addClass("hide");
            jQuery(".remove-bookmark-option").removeClass("hide");
        }

        // Remove the existing mouseup handler to prevent conflicts
    jQuery(document).off("mouseup.lineByLineContextMenu");
    
    // Add new mouseup handler that ONLY closes when NOT in edit mode
    jQuery(document).on("mouseup.lineByLineContextMenu", function (e) {
        var bannerCont = jQuery(".outsideContext");
        var contextMenu = jQuery("#contextMenu");
        var isEditMode = jQuery("span#" + currentTranslationUnitId.current).attr("edit-mode") === "on";
        
        // ONLY close if NOT in edit mode AND clicking outside
        if (!isEditMode && 
            !contextMenu.is(e.target) && 
            contextMenu.has(e.target).length === 0 &&
            !bannerCont.is(e.target) && 
            bannerCont.has(e.target).length === 0) {
            
            if (jQuery("#" + event?.currentTarget?.id).attr("contenteditable")) {
                jQuery("#" + event?.currentTarget?.id + " > .tu-html").html(currentSelectedTUHtml.current);
            }
            jQuery("span#" + event?.currentTarget?.id).removeAttr("edit-mode");
            jQuery("#" + event?.currentTarget?.id + " > .tu-html").html(currentSelectedTUHtml.current);
            jQuery("#contextMenu").remove();
            $('.linebykeydown').attr('aria-expanded', 'false');
            
            // Remove this handler after use
            jQuery(document).off("mouseup.lineByLineContextMenu");
        }
    });
    };

    //--------------------------------------HANDKLE CLICK ENDS-----------------------------------------------------

    jQuery(document).off("click", "#edit-tu").on("click", "#edit-tu", async function (e) {
        if (!(await validateAccess())) return;
        jQuery("span#" + currentTranslationUnitId.current).attr("edit-mode", "on");
        // Hide all list items except the edit option
        jQuery(".icr-options-list > li:not(.edit-option)").addClass("hide");

        // Show the edit container
        jQuery("#edit-tu-container").removeClass("hide");
        if (jQuery("span#" + currentTranslationUnitId.current).has("span[contenteditable]").length === 0) {
            markEditableContent(jQuery("span#" + currentTranslationUnitId.current).get(0));
            setTimeout(function () {
                jQuery("span#" + currentTranslationUnitId.current).trigger("focus");
            }, 10)
        }

        // Populate category (same formatting as IcrPreview)
        jQuery('#feedbackCategoryOptions').html('<option value=\"\">Select Category (Optional)</option>');
        if (feedbackCategoryList.current && feedbackCategoryList.current.length > 0) {
            feedbackCategoryList.current.forEach(function (cat) {
                const displayText = cat.fullDisplay ||
                    ((cat.errorCategory && (cat.errorCategory.display || cat.errorCategory.name)) ?
                        ((cat.errorCategory.display || formatCategoryType(cat.errorCategory.name)) + ': ' + (cat.display || formatCategoryName(cat.name)))
                        : (cat.display || cat.name || '')
                    );
                const val = cat.name || cat.id || '';
                jQuery('#feedbackCategoryOptions').append('<option value="' + val + '">' + jQuery('<div/>').text(displayText).html() + '</option>');
            });
        }

        // Populate severity (same as IcrPreview)
        jQuery('#feedbackSeverityOptions').html('<option value=\"\">Select Severity (Optional)</option>');
        if (feedbackSeverityList.current && feedbackSeverityList.current.length > 0) {
            feedbackSeverityList.current.forEach(function (sev) {
                const val = sev.name || sev.label || sev.value || sev;
                const disp = sev.display || sev.name || sev.label || ('' + sev);
                jQuery('#feedbackSeverityOptions').append('<option value="' + val + '">' + jQuery('<div/>').text(disp).html() + '</option>');
            });
        }


    });


    jQuery(document).off("click", "#edit-tu-submit").on("click", "#edit-tu-submit", function (e) {
        if (jQuery("span#" + currentTranslationUnitId.current).length) {

            let content = jQuery("span#" + currentTranslationUnitId.current + " > .tu-html");
            content.find("span[contenteditable=true]").each((index, element) => {
                var textInSpan = jQuery(element).text();
                if (textInSpan.trim() === "") {
                    textInSpan = "-";
                }
                jQuery(element).replaceWith(document.createTextNode(textInSpan));
            })
            content.find("[equiv-text]").each(function () {
                var encodedStr = encodeString($(this).attr("equiv-text"))
                $(this).attr("equiv-text", encodedStr);
            });

            let newTuRawText = content.html().replaceAll("<br>", "<br/>").replaceAll("&nbsp;", " ");
            const selectedCategory = jQuery('#feedbackCategoryOptions').find(":selected").val() || null;
            const selectedSeverity = jQuery('#feedbackSeverityOptions').find(":selected").val() || null;

            currentSelectedTUHtml.current = newTuRawText;
            window.parent.postMessage(JSON.stringify({
                projectTranslationAssetId: currentProjectTranslationAssetId.current,
                action: "SAVE_EDITED_TRANSLATION",
                docSegPos: currentDocSegPos.current,
                rawText: newTuRawText,
                isLineByLine: true,
                feedbackCategory: selectedCategory,
                feedbackSeverity: selectedSeverity
            }), parentHttpDomain);

            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');
            jQuery("#contextMenu").remove();
            jQuery("span#" + currentTranslationUnitId.current).removeAttr("edit-mode");
            $('.linebykeydown').attr('aria-expanded', 'false');

        }
    });

    const encodeString = (string) => {
        return string.replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }


    jQuery(document).on("keydown", '#edit-tu-container', function (event) {
        if (event.key === Constants.ESCAPE) {
            jQuery("#" + currentTranslationUnitId.current + " > .tu-html").html(currentSelectedTUHtml.current);
            jQuery("span#" + currentTranslationUnitId.current).removeAttr("edit-mode");
            jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');
            jQuery("#contextMenu").remove();
            $('#edit-tu').attr('aria-expanded', function (index, attr) {
                return attr === 'true' ? 'false' : 'true';
            });
        }

        if (document.activeElement.id === 'edit-tu-submit') {
            if (event.key === Constants.TAB && !event.shiftKey) {
                event.preventDefault();
                jQuery("#" + currentTranslationUnitId.current + " > .tu-html").html(currentSelectedTUHtml.current);
                jQuery("span#" + currentTranslationUnitId.current).removeAttr("edit-mode");
                jQuery(event.target).closest('.outsideContext').children().first().trigger('focus');
                jQuery("#contextMenu").remove();
                $('#edit-tu').attr('aria-expanded', function (index, attr) {
                    return attr === 'true' ? 'false' : 'true';
                });
            }
        }
    })



    jQuery(document).off("click", "#edit-tu-cancel").on("click", "#edit-tu-cancel", function (e) {
        jQuery("#" + currentTranslationUnitId.current + " > .tu-html").html(currentSelectedTUHtml.current);
        jQuery("span#" + currentTranslationUnitId.current).removeAttr("edit-mode");
        $('.linebykeydown').attr('aria-expanded', 'false');
        jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');
        jQuery("#contextMenu").remove();
    });


    //Line By Line History
    useEffect(() => {
        const handleShowHistoryClick = (e) => {
            window.parent.postMessage(JSON.stringify({
                projectId: projectId,
                action: "showHistory",
                docSegPos: +currentDocSegPos.current,
                translationUnitId: currentTranslationUnitId.current
            }), parentHttpDomain);
            jQuery("#contextMenu").remove();
        };

        jQuery(document).on("click", "#show-history", handleShowHistoryClick);

        return () => {
            jQuery(document).off("click", "#show-history", handleShowHistoryClick);
        };
    }, []);


    //Line By Line Add Bookmark
    useEffect(() => {
        const handleAddBookmarkClick = (e) => {            
            window.parent.postMessage(JSON.stringify({
                projectAssetFileId: currentTranslationUnitId.current,
                action: "bookmark",
                docSegPos: +currentDocSegPos.current
            }), "*");
            jQuery("#contextMenu").remove();
        };

        jQuery(document).on("click", "#bookmark", handleAddBookmarkClick);

        return () => {
            jQuery(document).off("click", "#bookmark", handleAddBookmarkClick);
        };
    }, []);



    //Line By Line Remove Bookmark
    useEffect(() => {
        const handleRemoveBookmarkClick = (e) => {
            window.parent.postMessage(JSON.stringify({
                projectAssetFileId: currentTranslationUnitId.current,
                action: "REMOVE_BOOKMARK"
            }), parentHttpDomain);
            jQuery("#contextMenu").remove();
        };

        jQuery(document).on("click", "#remove-bookmark", handleRemoveBookmarkClick);

        return () => {
            jQuery(document).off("click", "#remove-bookmark", handleRemoveBookmarkClick);
        };
    }, []);


     //Line By Line close menu
    useEffect(() => {
        const handleCloseMenuButtonClick = (e) => {
            $('.linebykeydown').attr('aria-expanded', 'false');
            jQuery(e.target).closest('.outsideContext').children().first().trigger('focus');
            jQuery("#contextMenu").remove();
        };

        jQuery(document).on("click", "#close-tu-menu", handleCloseMenuButtonClick);

        return () => {
            jQuery(document).off("click", "#close-tu-menu", handleCloseMenuButtonClick);
        };
    }, []);

    useEffect(() => {
        const handleRefreshMessage = (event) => {            
            if (event.origin === parentHttpDomain) {
                try {                    
                    const message = JSON.parse(event.data);
                    if (message.action === "REFRESH_LBL_FEEDBACK_LIST" && activeFilter === "COMMENTED") {
                        refreshFeedbackList();
                    }
                } catch (e) {
                    console.log("Error parsing refresh message:", e);
                }
            }
        };

        window.addEventListener("message", handleRefreshMessage);
        return () => {
            window.removeEventListener("message", handleRefreshMessage);
        };
    }, [activeFilter, parentHttpDomain]);


    function markEditableContent(node) {

        var nonWhitespaceMatcher = /\S/;
        var foundStartMarker = false;
        var foundEndMarker = false;

        function getTextNodes(node) {
            if (node != null) {
                if (jQuery(node).attr("name") === "tu-start") {
                    foundStartMarker = true;
                }

                if (jQuery(node).attr("name") === "tu-end") {
                    foundEndMarker = true;
                }

                if (node.nodeType === 3) {
                    if (nonWhitespaceMatcher.test(node.nodeValue)) {
                        if (foundStartMarker === true && foundEndMarker === false) {//do not add the text nodes after tu-end marker (if any)                        
                            const span = document.createElement('span');
                            span.setAttribute('contentEditable', true)

                            // Store the original content in a data attribute
                            span.setAttribute('data-original-content', node.nodeValue);

                            node.after(span);
                            span.appendChild(node);
                        }
                    }
                } else {
                    for (var i = 0, len = node.childNodes.length; i < len; ++i) {
                        getTextNodes(node.childNodes[i]);
                    }
                }
            }
        }
        getTextNodes(node);

    }

    function undoMarkEditableContent() {
        // Find all elements with the `contentEditable` attribute
        const editableElements = document.querySelectorAll("[contentEditable='true']");

        editableElements.forEach((element) => {
            // Restore the original content from the data attribute
            const originalContent = element.getAttribute('data-original-content');
            if (originalContent !== null) {
                const parent = element.parentNode;
                const textNode = document.createTextNode(originalContent);

                // Replace the editable span with the original text node
                parent.replaceChild(textNode, element);
            }
        });

        // Remove the `edit-mode` attribute from all elements
        const elementsWithEditMode = document.querySelectorAll("[edit-mode]");
        elementsWithEditMode.forEach((element) => {
            element.removeAttribute("edit-mode");
        });
    }

    return (
        <>

            <div id="line-by-line-view-content" className="icr-content-inner line-text flex-center resizable-x hide">
                <h6 className="hide m-show">Source - English</h6>
                <div className="icr-content-inner-left relative">
                    <div className="translate-content new-content video-main line-content">
                        <ul className="video-translated-content">
                            {translationUnits?.map((translationUnit) =>
                                <li  key={translationUnit.docSegPos}>
                                    <strong className="mr-15">{translationUnit.docSegPos}</strong>

                                    <span dangerouslySetInnerHTML={{ __html: translationUnit.rawSrcText }} ></span>
                                </li>
                            )}

                        </ul>
                    </div>
                </div>

                <div className="splitter resizer-x">
                    <button aria-label="drag content" className="splitter-icon" tabIndex="-1">
                        {splitterIcon}
                    </button>
                </div>
                <h6 className="hide m-show"></h6>
                <div className="icr-content-inner-right relative">
                    <div className="translate-content new-content video-main line-content">
                        <div className="filter-text flex-center">
                            <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'edit'}`}>
                                <button
                                    aria-label="edit"
                                    disabled={isFinalPreviewChecked || isLoadingFilter}
                                    className={activeFilter === "EDITED" ? "edit-button-active flex-center" : "flex-center"}
                                    onClick={toggleEditFilter}
                                    aria-pressed={activeFilter === "EDITED"}
                                >
                                    {isLoadingFilter && activeFilter === "EDITED" ? (
                                        <div className="spinner-small"></div>
                                    ) : (
                                        <>
                                            <p className="number" id="edit-count">{editedTusCount} </p>
                                            <p className="text">Edit</p>
                                        </>
                                    )}
                                </button>
                            </div>
                            <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'feedback'}`}>
                                <button
                                    aria-label="feedback"
                                    disabled={isFinalPreviewChecked || isLoadingFilter}
                                    className={activeFilter === "COMMENTED" ? "feedback-button-active flex-center" : "flex-center"}
                                    onClick={toggleFeedbackFilter}
                                    aria-pressed={activeFilter === "COMMENTED"}
                                >
                                    {isLoadingFilter && activeFilter === "COMMENTED" ? (
                                        <div className="spinner-small"></div>
                                    ) : (
                                        <>
                                            <p className="number" id="feedback-count">{feedbackCount}</p>
                                            <p className="text">Feedback</p>
                                        </>
                                    )}
                                </button>
                            </div>
                            <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'tm'}`}>
                                            <button
                                                aria-label="tm"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "TM" ? "leveraged-button-active flex-center" : "flex-center"}
                                                onClick= { toggleLeveragedTuFilter }
                                                aria-pressed={activeFilter === "TM"}
                                            >
                                                {isLoadingFilter && activeFilter === "TM" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="tm-count">{leveragedTuCount}</p>
                                                        <p className="text">TM</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'locked'}`}>
                                            <button
                                                aria-label="locked"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "LOCKED" ? "locked-button-active flex-center" : "flex-center"}
                                                onClick= { toggleLockedTuFilter }
                                                aria-pressed={activeFilter === "LOCKED"}
                                            >
                                                {isLoadingFilter && activeFilter === "LOCKED" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="locked-count">{lockedTuCount}</p>
                                                        <p className="text">Locked</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'aipe'}`}>
                                            <button
                                                aria-label="aipe"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "AIPE" ? "aipe-button-active flex-center" : "flex-center"}
                                                onClick= { toggleAIPETuFilter }
                                                aria-pressed={activeFilter === "AIPE"}
                                            >
                                                {isLoadingFilter && activeFilter === "AIPE" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="aipe-count">{aipeTuCount}</p>
                                                        <p className="text">AIPE</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>

                        </div>
                        <ul className="video-translated-content">


                            {translationUnits?.map((translationUnit) =>

                                <li className="translation-unit-list-view" key={translationUnit.id}>
                                    <span className="mr-15">
                                    </span>
                                    <span className="outsideContext">

                                        <span role="link" aria-expanded="false" tabIndex="0" id={translationUnit.id} className={translationUnit.bookmark ? "linebykeydown bookmark" : "linebykeydown"} onClick={(event) => handleClick(event, translationUnit.docSegPos, translationUnit.projectTranslationAssetId)} onKeyDown={(event) => handleClickKeydown(event, translationUnit.docSegPos, translationUnit.projectTranslationAssetId)}>
                                            <span name="tu-start"></span>
                                            <span class="tu-html" dangerouslySetInnerHTML={{
                                                __html: `${translationUnit.translations[translationUnit.translations.length - 1].rawText}`,
                                            }}
                                            ></span>
                                            <span name="tu-end"></span>
                                        </span>

                                        <div id={translationUnit.id + "-error"} style={{ color: "red" }}></div>
                                    </span>

                                </li>
                            )}

                        </ul>
                        <aside className="country-list icr-side-section">

                        </aside>
                    </div>
                </div>

            </div>
            {showFeedbackForm && (
                <FeedbackForm
                    onCancel={handleFeedbackCancel}
                    onSubmit={handleFeedbackSubmit}
                    categoryOptions={feedbackCategoryList.current}
                    severityOptions={feedbackSeverityList.current}
                    position={feedbackFormPosition}
                />
            )}
            {showSuccessNotification && (
            <SuccessNotification
                message={notificationMessage}
                onClose={() => setShowSuccessNotification(false)}
            />
        )}

        </>
    );

}